import { hasProperty } from '@/constants/routesLimited.js'
import type { HideObject } from 'plugins/router/types'

export const hideMeterReadingLimit: HideObject = {
	method: hasProperty,
	parameter: {
		store: 'setting',
		getter: 'getData',
		property: 'hide_meter_reading',
		value: false,
	},
}

export const hideTicket: HideObject = {
	method: hasProperty,
	parameter: {
		store: 'setting',
		getter: 'getData',
		property: 'hide_ticket',
		value: false,
	},
}

export const hideUpdateRequests: HideObject = {
	method: hasProperty,
	parameter: {
		store: 'setting',
		getter: 'getData',
		property: 'hide_update_requests',
		value: false,
	},
}
